import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const postCardReputationBetContainer = style({
  ...responsiveStyle({
    mobile: {
      gridArea: 'reputation',
      marginBottom: space.s12,
      marginTop: space.s12,
    },
    tablet: {
      gridArea: 'reputation',
      paddingLeft: space.s16,
      marginTop: space.s20,
      marginBottom: space.s20,
    },
    wide: { paddingLeft: space.s24 },
  }),
});

export const postCardReputationBet = style([
  {
    backgroundColor: themeVars.container.secondary.background.idle,
    borderRadius: borderRadius.r16,
  },
  responsiveStyle({
    mobile: {
      paddingTop: space.s4,
      paddingRight: space.s12,
      paddingBottom: space.s4,
      paddingLeft: space.s12,
    },
    tablet: {
      paddingTop: space.s8,
      paddingRight: space.s12,
      paddingBottom: space.s8,
      paddingLeft: space.s12,
    },
  }),
]);
